import { encodeArray } from 'util/turnto-utils'
import { GalleryConfig } from './api-service'
import getMediaListService from 'services/api/media-list'

export const GALLERY_FETCH_LIMIT = 25

export function getMediaList(
  skus: Array<string>,
  tags: Array<string>,
  offset: number,
  galleryConfig: GalleryConfig
) {
  return getMediaListService.mediaList({
    skus: encodeArray(skus),
    offset,
    limit: GALLERY_FETCH_LIMIT,
    sort: galleryConfig.sortOrder,
    tags: encodeArray(tags),
    minCharCount: galleryConfig.minTextContentCharacterCount,
    minWordCount: galleryConfig.minTextContentWordCount,
    includeProductSiblings: galleryConfig.includeProductSiblings,
    includeSyndicated: galleryConfig.includeSyndicated
  })
}
